import { gql } from '@apollo/client';

export const mutation = gql`
  mutation CreateWebhookConfig($url: String!, $eventTypes: [String!]!, $enabled: Boolean) {
    create_webhook_config(url: $url, eventTypes: $eventTypes, enabled: $enabled) {
      id
      hmac_secret
      url
      event_types
      created_at
      enabled_at
    }
  }
`;

export function buildVariables({ url, eventTypes, enabled }) {
  return { url, eventTypes, enabled };
}
